<!--
  优惠券详情
  lovi 2020-07-03
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('personal.coupon')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    >
      <img
        slot="right"
        v-if="detail.usage_status < 2"
        @click="shareFlag = true"
        class="icon_share"
        src="@/assets/images/personal/icon_share@2x.png"
      />
    </van-nav-bar>
    <div class="scroll-wrapper">
      <div class="item" v-if="detail.id">
        <div
          class="item-t"
          :class="detail.coupon_type == 2 ? 'style2' : 'style1'"
        >
          <div class="title">
            <div class="logo">
              <img :src="httpUrl + detail.icon" />
            </div>

            <h3>{{ detail.coupon_name }}</h3>
          </div>
          <div class="content">
            <div class="money">{{ detail.coupon_discount_amount }}P</div>
            <div class="info">
              <h4>
                {{
                  detail.coupon_type == 2
                    ? $t("coupon.unlimited")
                    : $t("coupon.upTo") +
                      detail.coupon_amount +
                      "P" +
                      $t("coupon.available")
                }}
              </h4>
              <span class="ticket">
                {{
                  detail.coupon_type == 2
                    ? $t("coupon.voucher")
                    : $t("coupon.cashback")
                }}
              </span>
              <p>
                {{ detail.end_time }}
                <span v-if="detail.due">{{ $t("coupon.AboutToExpired") }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="item-m">
          <span
            :class="{
              style2: detail.coupon_type == 2,
              disabled: detail.usage_status == 2 || detail.usage_status == 3
            }"
            @click="clickButton(detail.usage_status, detail.id)"
          >
            {{
              detail.usage_status == 0
                ? $t("coupon.getRightNow")
                : detail.usage_status == 1
                ? $t("coupon.goUse")
                : detail.usage_status == 2
                ? $t("coupon.used")
                : $t("coupon.expired")
            }}
          </span>
        </div>
        <div class="item-b">
          <p class="text-gray">
            {{ $t("coupon.description") }}：{{ detail.explanation }}
          </p>
          <p class="text-gray">
            {{ $t("coupon.instruction") }}：{{ detail.notice }}
          </p>
        </div>
        <div class="cro-wrap left">
          <div class="cro top"></div>
          <div class="cro bottom"></div>
        </div>
        <div class="cro-wrap right">
          <div class="cro top"></div>
          <div class="cro bottom"></div>
        </div>
      </div>
    </div>

    <!-- 分享 -->
    <van-action-sheet
      v-model="shareFlag"
      class="share-action"
      :cancel-text="$t('common.cancel')"
    >
      <div
        class="copylink icon-copy"
        :data-clipboard-text="url"
        @click="copyText"
      >
        <img src="@/assets/images/personal/icon_copylink@2x.png" />
        <p>{{ $t("common.copyLink") }}</p>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Clipboard from "clipboard";
export default {
  name: "couponDetail",
  meta: {
    service: false // 客服
  },
  components: {},
  data() {
    return {
      id: "",
      userId: "",
      url: "",
      shareFlag: false,
      detail: {}
    };
  },
  created() {
    this.id = this.$route.query.id || "";
    this.userId = this.$route.query.userId || this.userInfo.id;
    this.url = window.location.href + "&userId=" + this.userId;
    this.couponDetails();
  },
  mounted() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    copyText() {
      var clipboard = new Clipboard(".icon-copy");
      clipboard.on("success", e => {
        console.info("Action:", e.action);
        this.$toast(this.$t("common.copySuccess"));
        clipboard.destroy(); // 释放内存
      });
      clipboard.on("error", e => {
        console.info("error:", e.action);
        this.$toast(this.$t("common.browserNoCopy"));
        clipboard.destroy(); // 释放内存
      });
      this.shareFlag = false;
    },
    clickButton(status, id) {
      // 点击按钮操作
      // status 0未领取、1已领取、2已使用
      console.log(status, id);
      if (status == 0) {
        this.couponShare(id);
      } else if (status == 1) {
        this._linkFun("/life");
      }
    },
    couponShare(id) {
      // 领取分享的优惠券
      let vm = this;
      let params = {};
      params.share_user_id = vm.userId;
      params.manystore_coupon_id = id;
      vm.$post("/app/user/couponShare", params, {
        loading: true,
        alert: true
      }).then(res => {
        console.log("couponShare", res);
        vm.$toast(res.msg);
      });
    },
    couponDetails() {
      // 优惠券详情
      let vm = this;
      vm.$post(
        "/app/user/couponDetails",
        { id: vm.id },
        { loading: true }
      ).then(res => {
        console.log("couponDetails", res);
        this.detail = res;
      });
    }
  },
  watch: {}
  // beforeDestroy: {}
};
</script>

<style lang="less" scoped>
@images: "~@/assets/images/";
.scroll-wrapper {
  background: #f4f4f4;
}
.icon_share {
  width: 20px;
  height: 20px;
}
.share-action {
  /deep/.van-action-sheet__content {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0;
    .copylink {
      display: flex;
      justify-content: center;
      flex-direction: column;
      text-align: center;
      font-size: 14px;
      line-height: 1;
      img {
        margin: 0 auto 5px;
        width: 48px;
        height: 48px;
      }
    }
  }
}
.item {
  position: relative;
  margin: 10px;
  // padding: 0 15px;
  line-height: 1;
  background: #fff;
  border-radius: 8px;
  // border: 1px solid #58c4e6;
  box-shadow: 0px 2px 2px 0px rgba(221, 221, 221, 0.5);
  overflow: hidden;
  .item-t {
    color: #fff;
    padding: 0 10px;
    background: linear-gradient(180deg, #ff8c8c 0%, #fd4553 100%);
    &.style2 {
      background: linear-gradient(180deg, #ff8856 0%, #ff5140 100%);
    }
    .title {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 10px 0;
      border-bottom: 1.1px dashed #ececec;
      .logo {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 10px;
        width: 30px;
        height: 30px;
        border-radius: 4px;
        overflow: hidden;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
      h3 {
        font-size: 16px;
        font-weight: 400;
      }
    }
    .content {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 10px 0;
      .money {
        margin-right: 10px;
        width: 140px;
        text-align: center;
        font-size: 32px;
      }
      .info {
        flex: 1;
        h4 {
          font-size: 14px;
          line-height: 1;
          font-weight: 400;
        }
        .ticket {
          margin: 8px 0;
          display: inline-block;
          padding: 2px 5px;
          line-height: 1.2;
          border: 1.1px solid #fff;
          border-radius: 3px;
        }
      }
    }
  }
  .item-m {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 10px;
    // button {
    //   min-width: 80px;
    // }
    span {
      display: inline-block;
      width: 80px;
      text-align: center;
      font-size: 14px;
      line-height: 24px;
      color: #fd4553;
      border: 1.1px solid #fd4553;
      border-radius: 4px;
      &.disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }
      &.style2 {
        color: #fe7800;
        border-color: #fe7800;
      }
    }
  }
  .item-b {
    padding: 0 10px 10px 10px;
    p {
      padding: 8px 0;
      line-height: 1.2;
      border-top: 1.1px dashed #dfdfdf;
    }
  }

  .info1 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1.1px dashed #ececec;
    .left {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 10px;
      width: 60px;
      height: 60px;
      border-radius: 4px;
      overflow: hidden;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    .center {
      flex: 1;
      text-align: left;
      h3 {
        font-size: 14px;
        line-height: 1;
        font-weight: 400;
      }
      .ticket {
        margin: 5px 0;
        display: inline-block;
        padding: 2px 5px;
        line-height: 1.2;
        color: #fc3c46;
        border: 1.1px solid #fc3c46;
        border-radius: 3px;
        &.style2 {
          color: #fe7800;
          border: 1.1px solid #fe7800;
        }
      }
    }
    .right {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin-left: 10px;
      h4 {
        margin-bottom: 5px;
        font-size: 16px;
      }
    }
  }
  .use-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 36px;
    overflow: hidden;
    p {
      margin-right: 10px;
      flex: 1;
    }
    /deep/.van-button--mini {
      padding: 0 10px;
    }
  }
  .cro-wrap {
    z-index: 1;
    position: absolute;
    top: 44px;
    width: 6px;
    height: 12px;
    &.left {
      left: 0;
      .top {
        // border-bottom-color: #58c4e6;
        // border-right-color: #58c4e6;
        border-radius: 0px 0px 6px 0px;
      }
      .bottom {
        // border-top-color: #58c4e6;
        // border-right-color: #58c4e6;
        border-radius: 0px 6px 0px 0px;
      }
    }
    &.right {
      right: 0;
      .top {
        // border-bottom-color: #58c4e6;
        // border-left-color: #58c4e6;
        border-radius: 0px 0px 0px 6px;
      }
      .bottom {
        // border-top-color: #58c4e6;
        // border-left-color: #58c4e6;
        border-radius: 6px 0px 0px 0px;
      }
    }
    .cro {
      position: absolute;
      width: 6px;
      height: 6px;
      background: #f4f4f4;
      // border: 1px solid #f4f4f4;
      &.top {
        bottom: 0;
      }
      &.bottom {
        top: 0;
      }
    }
  }
}
</style>
